import { STORY } from '../actions/Types';
const INITIAL_STATE = {
  storyData:{},
}
export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case STORY:
        return {...state, storyData: action.payload};
    default:
        return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/StoryReducer.js